import axios from './axiosConfig';
import queryString from 'query-string';
import { apis } from './params';

// Interface for API response
export interface PaymentModeResponse {
  status: boolean;
  statusDescription: string;
  statusCode: number;
}

// Service to update customer payment mode
export const updateCustomerPaymentMode = async (
  customerId: number,
  isCod: boolean,
  reason: string
): Promise<PaymentModeResponse> => {
  try {
    const params: any = {
      customerId,
      isCod,
      reason
    };
    const response = await axios.post(
      `${apis.UPDATE_CUSTOMER_PAYMENT_MODE}?${queryString.stringify(params)}`,
      {}
    );
    return response.data;
  } catch (error: any) {
    console.error('Error updating customer payment mode:', error);
    throw error;
  }
};

export default {
  updateCustomerPaymentMode
};